import { ERA_OPTIONS, REGIONS, SORT_OPTIONS, type EraKey, type SortKey } from "@/utils/movie";

interface FilterBarProps {
  region: string;
  onRegionChange: (value: string) => void;
  era: EraKey;
  onEraChange: (value: EraKey) => void;
  sort?: SortKey;
  onSortChange?: (value: SortKey) => void;
}

function Segment<T extends string>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { key: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <span className="shrink-0 text-xs text-foreground-500 sm:w-14">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={`rounded-full px-3 py-1.5 text-sm transition-colors whitespace-nowrap ${
              value === option.key
                ? "bg-primary-500 text-foreground-950 font-medium"
                : "bg-background-200/60 text-foreground-600 hover:text-foreground-950"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  region,
  onRegionChange,
  era,
  onEraChange,
  sort,
  onSortChange,
}: FilterBarProps) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
      <Segment
        label="地区"
        options={REGIONS.map((item) => ({ key: item, label: item }))}
        value={region}
        onChange={onRegionChange}
      />
      <Segment label="年代" options={ERA_OPTIONS} value={era} onChange={onEraChange} />
      {sort && onSortChange && <Segment label="排序" options={SORT_OPTIONS} value={sort} onChange={onSortChange} />}
    </div>
  );
}